import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Button, Stack, Alert, Autocomplete } from '@mui/material';
import { getAllCurrencies } from '../utils/currencyList';

const TaxCurrencySettings = () => {
  const [taxRate, setTaxRate] = useState('');
  const [currency, setCurrency] = useState('');
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch current settings from backend
    fetch('/api/settings/tax-currency')
      .then(res => res.json())
      .then(data => {
        setTaxRate(data.taxRate || '');
        setCurrency(data.currency || '');
      });
    // Load currency options
    setCurrencyOptions(getAllCurrencies());
  }, []);

  const handleSave = async (e) => {
    e.preventDefault();
    setMessage(null);
    setLoading(true);
    try {
      const res = await fetch('/api/settings/tax-currency', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ taxRate, currency }),
      });
      const data = await res.json();
      if (res.ok) {
        setMessage({ type: 'success', text: 'Settings updated.' });
      } else {
        setMessage({ type: 'error', text: data.error || 'Update failed.' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Update failed.' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box component="form" onSubmit={handleSave} sx={{ maxWidth: 400 }}>
      <Stack spacing={2}>
        <TextField
          label="Default Tax Rate (%)"
          type="number"
          value={taxRate}
          onChange={e => setTaxRate(e.target.value)}
          inputProps={{ min: 0, max: 100, step: 0.01 }}
          fullWidth
        />
        <Autocomplete
          options={currencyOptions}
          getOptionLabel={option => `${option.currency} (${option.code}) ${option.symbol}`}
          value={currencyOptions.find(opt => opt.code === currency) || null}
          onChange={(_, newValue) => setCurrency(newValue ? newValue.code : '')}
          renderInput={params => (
            <TextField {...params} label="Currency" fullWidth />
          )}
          isOptionEqualToValue={(option, value) => option.code === value.code}
        />
        <Button type="submit" variant="contained" disabled={loading}>
          Save
        </Button>
        {message && <Alert severity={message.type}>{message.text}</Alert>}
      </Stack>
    </Box>
  );
};

export default TaxCurrencySettings;
